export default {
  PREPARED: 'PREPARED',
  IN_PROGRESS: 'IN_PROGRESS',
  ENDED: 'ENDED',
  SUSPENDED: 'SUSPENDED',
  ABANDONED: 'ABANDONED',
};
